"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatementType = exports.ChunkType = void 0;
var ChunkType;
(function (ChunkType) {
    ChunkType["OBJECTS"] = "objects";
    ChunkType["WHEN"] = "when";
})(ChunkType || (exports.ChunkType = ChunkType = {}));
var StatementType;
(function (StatementType) {
    StatementType["MOVE"] = "move";
    StatementType["DELETE"] = "delete";
})(StatementType || (exports.StatementType = StatementType = {}));
